<template>
    <div v-for="item in items" :key="item.id" class="user-profile-answer-item d-flex align-center justify-content-between" :class="item.isAnswered ? 'is_answered' : ''">
        <div class="answered-badge post-answer-count">
            {{item.count}}
        </div>
        <div class="user-profile-answer-content">
            <router-link class="transition-3s" :to="{name: 'question-single', params: {question_id: item.id}}">{{item.title}}</router-link>
        </div>
        <span class="answer-date d-block">{{item.date}}</span>
    </div>
</template>

<script>
export default {
    name: 'QuestionAndAnswerBox',
    props: ['items']
}
</script>